import { Row, Col, Card, Table, DatePicker, Tag } from "antd";

import React, { useState, useEffect } from "react";

import moment from "moment";
import lang from "../../helper/langHelper";
const { RangePicker } = DatePicker;

function LastSurveyProducts({ data, loading, isShow = true }) {
  const [list, setList] = useState(data);
  const [pagination, setPagination] = useState(5);

  useEffect(() => {
    if (!data) return;
    setList(data);
    setPagination(data?.length);
    console.log("data ::", data);
  }, [data]);

  const columns = [
    {
      title: "TEAM NAME / LEADER NAME",
      render: (_, record) => {
        const { teamName, surveyType, leaderName } = record;

        if (surveyType === "Leader" || surveyType === "FollowUpLeader") {
          return <div>{leaderName || teamName || "-"}</div>;
        }

        return <div>{teamName || "-"}</div>;
      },
    },
      {
      title: "User Type",
      dataIndex: "requesterId",
        render: (_, {requesterId}) => {
        if (!requesterId) return "-";
        return requesterId.type === "master_facilitator" ? "MF" : "CP";
      },
    },
      {
      title: "Requester Name",
      dataIndex: "requesterId",
        render: (_, {requesterId}) => {
        if (!requesterId) return "-";
        return requesterId.name;
      },
    },
    //  {
    //   title: "Generated Date",
    //   key: "dateGenerated",
    //   dataIndex: "dateGenerated",
    //   render: (_, { dateGenerated }) => {
    //     return new Date(dateGenerated).toLocaleDateString();
    //   },
    // },
    ...(isShow
      ? [
          {
            title: "Survey",
            dataIndex: "surveyType",
            key: "surveyType",
            render: (surveyType) => {
              let displayText = "-";

              switch (surveyType) {
                case "Team":
                  displayText = "TPS for Team";
                  break;
                case "Leader":
                  displayText = "TPS for Leader";
                  break;
                case "Foundation":
                  displayText = "TPS Foundations";
                  break;
                case "FollowUpTeam":
                  displayText = "Follow up TPS for Team";
                  break;
                case "FollowUpLeader":
                  displayText = "Follow up TPS for Leader";
                  break;
                case "FollowUpFoundation":
                  displayText = "Follow up for TPS Foundations";
                  break;
                default:
                  displayText = "-";
              }

              return displayText;
            },
          },
        ]
      : []),
    {
      title: "STATUS",
      key: "status",
      render: (_, { status, isDeleted, _id }) => {
        let color = "red";
        let text = status;

        if (isDeleted) {
          text = "Deleted";
          color = "red";
        } else if (status === "Open") {
          color = "green";
        } else if (status === "Closed") {
          color = "volcano"; // closed ke liye alag color
        }

        return (
          <Tag color={color} key={_id}>
            {text}
          </Tag>
        );
      },
    },

    {
      title: "Registration date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return new Date(created_at).toLocaleDateString();
      },
    },
  ];

  return (
    <>
      <div className="tabled bannerMain">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <div className="table-responsive customPagination">
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                pagination={{
                  defaultPageSize: 10,
                  responsive: true,
                  total: pagination,
                  // showSizeChanger: true,
                  // pageSizeOptions: ["10", "20", "30", "50"],
                }}
                className="ant-border-space"
              />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default LastSurveyProducts;
